export default __webpack_public_path__ + "static/media/connect-dark.d02d1555.png";